export default __webpack_public_path__ + "static/media/Grupo 22@2x.eb5bef9c.png";